module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "subpage affairs3"
  }, [_c('div', {
    staticClass: "headLine clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("材料")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-button', {
    staticClass: "add",
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.fliesHandle('add')
      }
    }
  }, [_vm._v("添加")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listDat,
      "header-row-class-name": "tableHead"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "材料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "source",
      "label": "材料来源"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "originalNumber",
      "label": "原件份数",
      "align": "center",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "photocopyNumber",
      "label": "复印件份数",
      "align": "center",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.fliesHandle('edit', scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.fliesHandle('remove', scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('newMet', {
    ref: "newMet",
    on: {
      "goAdd": _vm.goAdd
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-d36f013a"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/affairs/src/Subpage3.vue
// module id = 1566
// module chunks = 1